import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useChangePassword, useGetProfile, useUpdateProfile } from './api';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';
import MultiCoinValidator from 'multicoin-address-validator';
import { Avatar } from '@mui/material';
import { stringAvatar } from '../../lib/avatar';
import { useNavigate } from 'react-router-dom';
import FlagsSelect from 'react-flags-select';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-date-picker';
import moment from 'moment/moment';
import { Calendar } from 'lucide-react';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import countryCodeMapping from './country';

const Myprofile = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
   
    const [updProf, setUpdProf] = useState(false);

    const { t } = useTranslation()






    const validationSchema = Yup.object({
        userName: Yup.string().required(t("Name is required")).matches(/^[A-Za-z\s]+$/, t("Name must only contain letters and spaces")).min(3, t("Name must be at least 3 characters"))
            .max(20, t("Name must be at most 20 characters")),
        email: Yup.string().required(t("Email is required")).email(t("Invalid email format")).matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]+\.[a-zA-Z]{2,}$/, t("Invalid email format"))
            .matches(/@([a-zA-Z.-]+)$/, t("Email domain must not contain numbers after @")),
        mobileNumber: Yup.number()
            .required(t("Phone number is required")),
        dateOfBirth: Yup.date()
            .required(t("Date of Birth is required"))
            .typeError(t('Date of Birth is Required'))
        ,
        country: Yup.string(),
            
        walletAddress: Yup.string()
            .required(t("Wallet address is required"))
            .required(t('Wallet Address is required'))
            .test((val, validate) => {
                const isValidAddress = MultiCoinValidator.validate(val, "ETH");
                if (isValidAddress) return val
                return validate.createError({ message: t("Invalid Address") });
            }),
        profile: Yup.mixed()
            .test("required", t("Profile is required"), (file) => !!file),


    });
    const { control, register, handleSubmit, formState: { errors, isDirty, isValid }, trigger, setValue, setError, clearErrors, getValues } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        defaultValues: {
            userName: '',
            email: '',
            dateOfBirth: '',
            mobileNumber:'',
            nationality: '',
            walletAddress: '',
            profile: ''
        }
    });


    const Schema = Yup.object({



        currentPassword: Yup.string()
            .required(t("Password is required"))
            .min(6, t("Password must be at least 6 characters"))
            .matches(/[A-Z]/, t("Password must contain at least one capital letter"))
            .matches(/\d/, t("Password must contain at least one number"))
            .matches(/[^A-Za-z0-9]/, ("Password must contain at least one special character")),
        newPassword: Yup.string()
            .required(t("Password is required"))
            .min(6, t("Password must be at least 6 characters"))
            .matches(/[A-Z]/, t("Password must contain at least one capital letter"))
            .matches(/\d/, t("Password must contain at least one number"))
            .matches(/[^A-Za-z0-9]/, t("Password must contain at least one special character")),
        confirmPassword: Yup.string()
            .required(t("Confirm password is required"))
            .oneOf([Yup.ref('newPassword'), null], t("Passwords must match")),

    });

    const { register: userRegister, handleSubmit: userSubmit, formState: { errors: userError }, reset } = useForm({
        resolver: yupResolver(Schema),
        mode: 'onChange',
        reValidateMode: 'onChange'
    });


  
 
    const { data: getProfile,isLoading } = useGetProfile()

    const [selected, setSelected] = useState(getProfile?.data?.country ? getProfile?.data?.country : "Select a Country");

    const updateProfile = useUpdateProfile()
    const userChangePassword = useChangePassword()
    const [showPassword, setShowPassword] = useState("password");
    const [showCPassword, setShowCPassword] = useState("password");
    const [showCNPassword, setShowCNPassword] = useState("password");
    const [profileimg, setProfileimg] = useState('');

    const { isloading, setIsloading } = useModalContext();
    const navigate = useNavigate()

   

    useEffect(() => {
        if (getProfile?.data) {
            setValue("userName", getProfile?.data?.userName || "");
            setValue("email", getProfile?.data?.email || "");
            setValue("mobileNumber", String(getProfile?.data?.mobileNumber || "") || "");
            const formattedDate = getProfile?.data?.dateOfBirth
                ? new Date(getProfile?.data?.dateOfBirth).toLocaleDateString('en-CA')  // 'en-CA' ensures YYYY-MM-DD format
                : '';

            setValue("dateOfBirth", formattedDate || "");
            setValue("country", getProfile?.data?.country || "Select Country");
            setValue("walletAddress", getProfile?.data?.walletAddress || "");
            setValue("profile", getProfile?.data?.profile || "");

            const phoneNumber = String(getProfile?.data?.countryCode || '');

           

            const countryFromPhone = countryCodeMapping[`+${phoneNumber}`];

           

            if (countryFromPhone) {

                setSelected(countryFromPhone);
            }
        }
    }, [getProfile?.data]);


    const readFileAsync1 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = btoa(reader.result);
                resolve(`data:${file.type};base64,${base64Data}`);
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }

    const handleProfile = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width <= 6000 && imgCheck.height <= 6000) {

                    if (img.size < 2 * 1024 * 1024) {
                        await readFileAsync1(img)
                        setProfileimg(img);
                        setValue("profile", img)
                        setUpdProf(true)
                    } else {
                        setError("profile", { message: t("Image Size Must be Less than 2MB.") });
                        setUpdProf(false)
                    }
                } else {
                    setError("profile", { message: t("Image Dimensions should be 6000 x 6000 Pixels.") });
                    setUpdProf(false)
                }
            };

            imgCheck.onerror = (error) => {
            };
        }
        reader.onerror = (error) => {
        };
        reader.readAsDataURL(img);
    }
    const onSubmit = async (data) => {

        setIsloading(true)
        try {
            let formData = new FormData();
            formData.append("userName", data.userName)
            formData.append("email", data.email)
            formData.append("phoneNumber", data.mobileNumber)
            formData.append("address", data.walletAddress)
            formData.append("country", selected || data?.country)
            formData.append("dateOfBirth", data.dateOfBirth)
            formData.append("profile", data.profile)
            const response = await updateProfile.mutateAsync(formData)
            if (response?.status) {
                setIsloading(false)
                navigate('/dashboard')

            }

        } catch (error) {
            setIsloading(false)
        } finally {
            setIsloading(false)
        }

    };

    const passwordSubmit = async (data) => {
        setIsloading(true)
        try {
            const response = await userChangePassword.mutateAsync(data)
            if (response?.status) {
                reset({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });
                sessionStorage.removeItem("user_JWT")
                navigate('/')
            }

        } catch (error) {

        } finally {
            setIsloading(false)
        }
    }

    

    

    const handleShowPassword = (name) => {
        if (name == "psw") {
            const ptype = showPassword === "text" ? "password" : "text";
            setShowPassword(ptype);
        } else if (name == "cpsw") {
            const ptype1 = showCPassword === "text" ? "password" : "text";
            setShowCPassword(ptype1);
        } else if (name == "cnpsw") {
            const ptype2 = showCNPassword === "text" ? "password" : "text";
            setShowCNPassword(ptype2);
        }
    };

    const handleSelectChange = (code) => {
        setSelected(code);
        setValue("nationality", code);

    };
   

const displayWalletAddress = () => {
    if (isLoading) return "-";
    const walletAddress = getProfile?.data?.walletAddress;
    if (walletAddress) {
        return `${walletAddress.slice(0, 10)}...${walletAddress.slice(-7)}`;
    }
    return "-";
};
    return (
        <>
            {isloading && <Loader />}
            <div className="MyPrflPg">
                <div className="row  CustRw">
                    <div className="col-lg-8 CustPad">
                        <div className="MyPrflDts">
                            <div className="MyPrflDtsTp">
                                <h4>{t('Profile Details')}</h4>
                            </div>
                            <div className="MyPrflTbs">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            <span>{t('Personal Data')}</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            <span>{t('Change Password')}</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="MyPrflDtsRw row CustRw">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Full Name')}</label>
                                                        <input className="form-control" type="text" placeholder="John Deo" {...register('userName')} autoFocus/>
                                                        {errors.userName && <span className="text-danger">{errors.userName.message}</span>}

                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Email Address')}</label>
                                                        <input className="form-control" type="text" placeholder="johndeo@gmail.com" {...register('email')} readOnly />
                                                        {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Mobile Number')}</label>
                                                        <input className="form-control" type="text" placeholder="John Deo" {...register('mobileNumber')} disabled/>

                                                       
                                                        {errors.mobileNumber && <span className="text-danger">{errors.mobileNumber.message}</span>}

                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Date of Birth')}</label>
                                                        <Controller
                                                            control={control}
                                                            name="dateOfBirth"
                                                            render={({ field: { onChange } }) => (

                                                                <DatePicker
                                                                    className='form-control'
                                                                    onChange={onChange}
                                                                    format="d-MM-y"
                                                                    dayPlaceholder="DD"
                                                                    monthPlaceholder="MM"
                                                                    yearPlaceholder="YYYY"
                                                                    value={getValues("dateOfBirth")}
                                                                    maxDate={moment().subtract(18, 'years').toDate()} // Only allow dates for users over 18
                                                                    clearIcon={null}
                                                                    calendarIcon={<Calendar />}

                                                                />
                                                            )}
                                                        />
                                                        {errors.dateOfBirth && <span className="text-danger">{errors.dateOfBirth.message}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Nationality')}</label>

                                                        <FlagsSelect
                                                            selectButtonClassName='country'
                                                            countries={[
                                                                "DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "TD", "KM", "CD", "CG", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW", "ST", "SA", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW",
                                                                "AF", "AL", "AM", "AO", "AR", "AT", "AU", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BN", "BO", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GT", "GU", "GW", "GY", "HK", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"
                                                            ]}
                                                            searchable
                                                            disabled
                                                            customLabels={{
                                                                "KE": "KENYA", "ZW": "ZIMBABWE", "ZA": "SOUTH AFRICA", "SD": "SUDAN", "AO": "ANGOLA", "CM": "CAMEROON", "AF": "AFGHANISTAN", "BJ": "BENIN", "IN": "INDIA", "DZ": "ALGERIA", "BW": "BOTSWANA", "BF": "BURKINA FASO", "BI": "BURUNDI", "CV": "CAPE VERDE", "CF": "CENTRAL AFRICAN REPUBLIC", "TD": "CHAD", "KM": "COMOROS", "CD": "CONGO (DEMOCRATIC REPUBLIC)", "CG": "CONGO (REPUBLIC)", "DJ": "DJIBOUTI", "EG": "EGYPT", "GQ": "EQUATORIAL GUINEA", "ER": "ERITREA", "SZ": "ESWATINI", "ET": "ETHIOPIA", "GA": "GABON", "GM": "GAMBIA", "GH": "GHANA", "GN": "GUINEA", "GW": "GUINEA-BISSAU", "LS": "LESOTHO", "LR": "LIBERIA", "LY": "LIBYA", "MG": "MADAGASCAR", "MW": "MALAWI", "ML": "MALI", "MR": "MAURITANIA", "MU": "MAURITIUS", "MA": "MOROCCO", "MZ": "MOZAMBIQUE", "NA": "NAMIBIA", "NE": "NIGER", "NG": "NIGERIA", "RW": "RWANDA", "ST": "SAO TOME AND PRINCIPE", "SA": "SAUDI ARABIA", "SN": "SENEGAL", "SC": "SEYCHELLES", "SL": "SIERRA LEONE", "SO": "SOMALIA", "SS": "SOUTH SUDAN", "TZ": "TANZANIA", "TG": "TOGO", "TN": "TUNISIA", "UG": "UGANDA", "ZM": "ZAMBIA",
                                                                 "AL": "ALBANIA", "AM": "ARMENIA", "AR": "ARGENTINA", "AT": "AUSTRIA", "AU": "AUSTRALIA", "AZ": "AZERBAIJAN", "BA": "BOSNIA AND HERZEGOVINA", "BB": "BARBADOS", "BD": "BANGLADESH", "BE": "BELGIUM", "BG": "BULGARIA", "BH": "BAHRAIN",  "BN": "BRUNEI", "BO": "BOLIVIA", "BR": "BRAZIL", "BS": "BAHAMAS", "BT": "BHUTAN", "BV": "BOUVET ISLAND",  "BY": "BELARUS", "BZ": "BELIZE", "CA": "CANADA", "CC": "COCOS ISLANDS",   "CH": "SWITZERLAND", "CI": "IVORY COAST", "CK": "COOK ISLANDS", "CL": "CHILE",  "CN": "CHINA", "CO": "COLOMBIA", "CR": "COSTA RICA", "CU": "CUBA", "CW": "CURAÇAO", "CX": "CHRISTMAS ISLAND", "CY": "CYPRUS", "CZ": "CZECH REPUBLIC", "DE": "GERMANY",  "DK": "DENMARK", "DM": "DOMINICA", "DO": "DOMINICAN REPUBLIC",  "EC": "ECUADOR", "EE": "ESTONIA",  "EH": "WESTERN SAHARA",  "ES": "SPAIN",  "FI": "FINLAND", "FJ": "FIJI", "FM": "MICRONESIA", "FO": "FAROE ISLANDS", "FR": "FRANCE",  "GB": "UNITED KINGDOM", "GD": "GRENADA", "GE": "GEORGIA", "GF": "FRENCH GUIANA", "GG": "GUERNSEY",  "GI": "GIBRALTAR", "GL": "GREENLAND",  "GP": "GUADELOUPE", "GR": "GREECE", "GT": "GUATEMALA", "GU": "GUAM",  "GY": "GUYANA", "HK": "HONG KONG", "HN": "HONDURAS", "HR": "CROATIA", "HT": "HAITI", "HU": "HUNGARY", "ID": "INDONESIA", "IE": "IRELAND", "IL": "ISRAEL", "IM": "ISLE OF MAN",  "IO": "BRITISH INDIAN OCEAN TERRITORY", "IQ": "IRAQ", "IR": "IRAN", "IS": "ICELAND", "IT": "ITALY", "JE": "JERSEY", "JM": "JAMAICA", "JO": "JORDAN", "JP": "JAPAN",  "KG": "KYRGYZSTAN", "KH": "CAMBODIA", "KI": "KIRIBATI", "KN": "SAINT KITTS AND NEVIS", "KP": "NORTH KOREA", "KR": "SOUTH KOREA", "KW": "KUWAIT", "KY": "CAYMAN ISLANDS", "KZ": "KAZAKHSTAN", "LA": "LAOS", "LB": "LEBANON", "LC": "SAINT LUCIA", "LI": "LIECHTENSTEIN", "LK": "SRI LANKA",   "LT": "LITHUANIA", "LU": "LUXEMBOURG", "LV": "LATVIA",   "MC": "MONACO", "MD": "MOLDOVA", "ME": "MONTENEGRO", "MF": "SAINT MARTIN",  "MH": "MARSHALL ISLANDS", "MK": "NORTH MACEDONIA",  "MM": "MYANMAR", "MN": "MONGOLIA", "MO": "MACAU", "MP": "NORTHERN MARIANA ISLANDS", "MQ": "MARTINIQUE", "MS": "MONTSERRAT", "MT": "MALTA", "MV": "MALDIVES", "MX": "MEXICO", "MY": "MALAYSIA",  "NC": "NEW CALEDONIA",  "NF": "NORFOLK ISLAND",  "NI": "NICARAGUA", "NL": "NETHERLANDS", "NO": "NORWAY", "NP": "NEPAL", "NR": "NAURU", "NU": "NIUE", "NZ": "NEW ZEALAND", "OM": "OMAN", "PA": "PANAMA", "PE": "PERU", "PF": "FRENCH POLYNESIA", "PG": "PAPUA NEW GUINEA", "PH": "PHILIPPINES", "PK": "PAKISTAN", "PL": "POLAND", "PM": "SAINT PIERRE AND MIQUELON", "PN": "PITCAIRN", "PR": "PUERTO RICO", "PT": "PORTUGAL", "PW": "PALAU", "PY": "PARAGUAY", "QA": "QATAR", "RE": "REUNION", "RO": "ROMANIA", "RS": "SERBIA", "RU": "RUSSIA", "SB": "SOLOMON ISLANDS",  "SE": "SWEDEN", "SG": "SINGAPORE", "SH": "SAINT HELENA", "SI": "SLOVENIA", "SJ": "SVALBARD", "SK": "SLOVAKIA",  "SM": "SAN MARINO",   "SR": "SURINAME",   "SV": "EL SALVADOR", "SX": "SINT MAARTEN", "SY": "SYRIA",  "TC": "TURKS AND CAICOS ISLANDS",  "TF": "FRENCH SOUTHERN TERRITORIES",  "TH": "THAILAND", "TJ": "TAJIKISTAN", "TK": "TOKELAU", "TL": "EAST TIMOR", "TM": "TURKMENISTAN",  "TO": "TONGA", "TR": "TURKEY", "TT": "TRINIDAD AND TOBAGO", "TV": "TUVALU", "UA": "UKRAINE", "UM": "US MINOR OUTLYING ISLANDS", "US": "UNITED STATES", "UY": "URUGUAY", "UZ": "UZBEKISTAN", "VA": "VATICAN CITY", "VC": "SAINT VINCENT AND THE GRENADINES", "VE": "VENEZUELA", "VG": "VIRGIN ISLANDS", "VI": "VIRGIN ISLANDS", "VN": "VIETNAM", "VU": "VANUATU", "WF": "WALLIS AND FUTUNA", "WS": "SAMOA", "YE": "YEMEN", "YT": "MAYOTTE",  
                                                            }}
                                                            placeholder="Select a country"
                                                            selected={selected || getProfile?.data?.country || ''}
                                                            onSelect={handleSelectChange}
                                                        />
                                                        {errors.country && <span className="text-danger">{errors.country.message}</span>}

                                                    </div>


                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label>{t('Enter Your Wallet Address')}</label>
                                                        <input className="form-control" type="text" placeholder={t("Enter wallet Address")} disabled={getProfile?.data?.walletAddress} {...register('walletAddress')} />
                                                        {errors.walletAddress && <span className="text-danger">{errors.walletAddress.message}</span>}

                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group d-flex align-items-center PrflDvDts">
                                                        <div className='mr-4'>
                                                            <label>{t('Profile Image')}</label>
                                                            <div className='col-lg-12 px-0'>
                                                                <div className='PrflUpldDv'>
                                                                    <input className="form-control" type="file" role='button' style={{ position: 'absolute', opacity: '0' }} accept='.jpg,.png,.jpeg' name='profile'
                                                                        onChange={async (e) => {
                                                                            try {
                                                                                let img = e.target.files[0]

                                                                                const reader = new FileReader();
                                                                                clearErrors("profile")
                                                                                setValue("profile", null)
                                                                                setProfileimg(null)
                                                                                reader.onload = (event) => {
                                                                                    const bytes = new Uint8Array(event.target.result);
                                                                                    if ((bytes[0] === 0x89 && bytes[1] === 0x50) || (bytes[0] === 0xFF && bytes[1] === 0xD8)) {
                                                                                        handleProfile(e)
                                                                                        setValue("profile", img);
                                                                                        trigger("profile");
                                                                                    } else {
                                                                                        setError("profile", { message: t('Please select image file') })
                                                                                    }
                                                                                };
                                                                                reader.onerror = (error) => {
                                                                                };
                                                                                reader.readAsArrayBuffer(img);
                                                                            } catch (e) { }
                                                                        }}
                                                                    />

                                                                    <div className='PrflUpldDvCnt'>
                                                                        <div className='d-flex'>
                                                                            <img src={require('../../assets/images/eth.png').default} alt='' />
                                                                            <span>{t('Upload Image')}</span>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                {errors.profile && <p className='text-danger'>{errors.profile.message}</p>}

                                                            </div>
                                                        </div>
                                                        <Avatar {...stringAvatar('USER')}
                                                            src={profileimg && (profileimg instanceof File || profileimg instanceof Blob) ? URL?.createObjectURL(profileimg) : getProfile?.data?.profile}
                                                            sx={{ width: 150, height: 150 }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-lg-12'>
                                                    <div className='form-group'>
                                                        <button
                                                            className="btn CmnBtn px-4"
                                                            type="submit"
                                                            disabled={(!isDirty || !isValid) && !updProf} // Enable if mobile number is editable
                                                        >
                                                            {t("Update Profile")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>


                                        </form>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <div className="MyPrflDtsRw row CustRw">
                                            <div className="col-lg-6">
                                                <div className="form-group PrflFrmGrpDv">
                                                    <label >{t('Old Password')}</label>
                                                    <input className="form-control" type={showPassword}
                                                        {...userRegister('currentPassword')} />
                                                    <span >
                                                        <button
                                                            type="button"
                                                            className="InputIcon EpySty eyeslsIg"
                                                            name="psw"
                                                            onClick={() => handleShowPassword("psw")}
                                                        >
                                                            {showPassword === "password" ? (
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3">
                                                                        <path d="M21.2699 9.17999C20.9799 8.71999 20.6699 8.28999 20.3499 7.88999C19.9799 7.41999 19.2799 7.37999 18.8599 7.79999L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85C10.8099 15.85 9.37995 17.28 8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.17999Z" fill="#121212" />
                                                                        <path d="M14.0201 9.98001L9.98014 14.02C9.47014 13.5 9.14014 12.78 9.14014 12C9.14014 10.43 10.4201 9.14001 12.0001 9.14001C12.7801 9.14001 13.5001 9.47001 14.0201 9.98001Z" fill="#121212" />
                                                                        <path d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z" fill="#121212" />
                                                                        <path d="M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z" fill="white" />
                                                                        <path d="M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z" fill="white" />
                                                                    </g>
                                                                </svg>

                                                            ) : (


                                                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3" clipPath="url(#clip0_2002_6031)">
                                                                        <path d="M19.25 6.14993C16.94 2.51993 13.56 0.429932 10 0.429932C8.22 0.429932 6.49 0.949937 4.91 1.91994C3.33 2.89994 1.91 4.32993 0.75 6.14993C-0.25 7.71993 -0.25 10.2699 0.75 11.8399C3.06 15.4799 6.44 17.5599 10 17.5599C11.78 17.5599 13.51 17.0399 15.09 16.0699C16.67 15.0899 18.09 13.6599 19.25 11.8399C20.25 10.2799 20.25 7.71993 19.25 6.14993ZM10 13.0399C7.76 13.0399 5.96 11.2299 5.96 8.99994C5.96 6.76994 7.76 4.95995 10 4.95995C12.24 4.95995 14.04 6.76994 14.04 8.99994C14.04 11.2299 12.24 13.0399 10 13.0399Z" fill="#121212" />
                                                                        <path d="M10.0004 6.14001C8.43039 6.14001 7.15039 7.42002 7.15039 9.00002C7.15039 10.57 8.43039 11.85 10.0004 11.85C11.5704 11.85 12.8604 10.57 12.8604 9.00002C12.8604 7.43002 11.5704 6.14001 10.0004 6.14001Z" fill="white" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_2002_6031">
                                                                            <rect width="20" height="18" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>

                                                            )}
                                                        </button>
                                                    </span>

                                                    {userError.currentPassword && <span className="text-danger">{userError.currentPassword.message}</span>}

                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group PrflFrmGrpDv">
                                                    <label>{t('New Password')}</label>
                                                    <input className="form-control" type={showCPassword} {...userRegister('newPassword')} />
                                                    <span >
                                                        <button
                                                            type="button"
                                                            className="InputIcon EpySty eyeslsIg"
                                                            name="psw"
                                                            onClick={() => handleShowPassword("cpsw")}
                                                        >
                                                            {showCPassword === "password" ? (
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3">
                                                                        <path d="M21.2699 9.17999C20.9799 8.71999 20.6699 8.28999 20.3499 7.88999C19.9799 7.41999 19.2799 7.37999 18.8599 7.79999L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85C10.8099 15.85 9.37995 17.28 8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.17999Z" fill="#121212" />
                                                                        <path d="M14.0201 9.98001L9.98014 14.02C9.47014 13.5 9.14014 12.78 9.14014 12C9.14014 10.43 10.4201 9.14001 12.0001 9.14001C12.7801 9.14001 13.5001 9.47001 14.0201 9.98001Z" fill="#121212" />
                                                                        <path d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z" fill="#121212" />
                                                                        <path d="M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z" fill="white" />
                                                                        <path d="M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z" fill="white" />
                                                                    </g>
                                                                </svg>

                                                            ) : (


                                                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3" clipPath="url(#clip0_2002_6031)">
                                                                        <path d="M19.25 6.14993C16.94 2.51993 13.56 0.429932 10 0.429932C8.22 0.429932 6.49 0.949937 4.91 1.91994C3.33 2.89994 1.91 4.32993 0.75 6.14993C-0.25 7.71993 -0.25 10.2699 0.75 11.8399C3.06 15.4799 6.44 17.5599 10 17.5599C11.78 17.5599 13.51 17.0399 15.09 16.0699C16.67 15.0899 18.09 13.6599 19.25 11.8399C20.25 10.2799 20.25 7.71993 19.25 6.14993ZM10 13.0399C7.76 13.0399 5.96 11.2299 5.96 8.99994C5.96 6.76994 7.76 4.95995 10 4.95995C12.24 4.95995 14.04 6.76994 14.04 8.99994C14.04 11.2299 12.24 13.0399 10 13.0399Z" fill="#121212" />
                                                                        <path d="M10.0004 6.14001C8.43039 6.14001 7.15039 7.42002 7.15039 9.00002C7.15039 10.57 8.43039 11.85 10.0004 11.85C11.5704 11.85 12.8604 10.57 12.8604 9.00002C12.8604 7.43002 11.5704 6.14001 10.0004 6.14001Z" fill="white" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_2002_6031">
                                                                            <rect width="20" height="18" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            )}
                                                        </button>
                                                    </span>
                                                    {userError.newPassword && <span className="text-danger">{userError.newPassword.message}</span>}

                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group PrflFrmGrpDv">
                                                    <label>{t('Confirm New Password')}</label>
                                                    <input className="form-control" type={showCNPassword} {...userRegister('confirmPassword')} />
                                                    <span >
                                                        <button
                                                            type="button"
                                                            className="InputIcon EpySty eyeslsIg"
                                                            name="psw"
                                                            onClick={() => handleShowPassword("cnpsw")}
                                                        >
                                                            {showCNPassword === "password" ? (

                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3">
                                                                        <path d="M21.2699 9.17999C20.9799 8.71999 20.6699 8.28999 20.3499 7.88999C19.9799 7.41999 19.2799 7.37999 18.8599 7.79999L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85C10.8099 15.85 9.37995 17.28 8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.17999Z" fill="#121212" />
                                                                        <path d="M14.0201 9.98001L9.98014 14.02C9.47014 13.5 9.14014 12.78 9.14014 12C9.14014 10.43 10.4201 9.14001 12.0001 9.14001C12.7801 9.14001 13.5001 9.47001 14.0201 9.98001Z" fill="#121212" />
                                                                        <path d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z" fill="#121212" />
                                                                        <path d="M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z" fill="white" />
                                                                        <path d="M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z" fill="white" />
                                                                    </g>
                                                                </svg>
                                                            ) : (


                                                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g opacity="0.3" clipPath="url(#clip0_2002_6031)">
                                                                        <path d="M19.25 6.14993C16.94 2.51993 13.56 0.429932 10 0.429932C8.22 0.429932 6.49 0.949937 4.91 1.91994C3.33 2.89994 1.91 4.32993 0.75 6.14993C-0.25 7.71993 -0.25 10.2699 0.75 11.8399C3.06 15.4799 6.44 17.5599 10 17.5599C11.78 17.5599 13.51 17.0399 15.09 16.0699C16.67 15.0899 18.09 13.6599 19.25 11.8399C20.25 10.2799 20.25 7.71993 19.25 6.14993ZM10 13.0399C7.76 13.0399 5.96 11.2299 5.96 8.99994C5.96 6.76994 7.76 4.95995 10 4.95995C12.24 4.95995 14.04 6.76994 14.04 8.99994C14.04 11.2299 12.24 13.0399 10 13.0399Z" fill="#121212" />
                                                                        <path d="M10.0004 6.14001C8.43039 6.14001 7.15039 7.42002 7.15039 9.00002C7.15039 10.57 8.43039 11.85 10.0004 11.85C11.5704 11.85 12.8604 10.57 12.8604 9.00002C12.8604 7.43002 11.5704 6.14001 10.0004 6.14001Z" fill="white" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_2002_6031">
                                                                            <rect width="20" height="18" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            )}
                                                        </button>
                                                    </span>
                                                    {userError.confirmPassword && <span className="text-danger">{userError.confirmPassword.message}</span>}

                                                </div>
                                            </div>
                                            <div className='col-lg-12'>
                                                <div className='form-group'>
                                                    <button className='btn CmnBtn px-4' type='submit' onClick={userSubmit(passwordSubmit)}>{t('Update Password')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-4 col-md-6 CustPad">
                        <div className='DshbrdPrfl'>
                            <div className='DshbrdPrflTp'>
                                <h4>{t('Welcome')} <span>{getProfile?.data?.userName}</span></h4>
                            </div>
                            <div className='DshbrdPrflVrfy'>
                                <label>{t('Your Account Status')}</label>
                                <h5>{t('Email Verified')}<img src={require('../../assets/images/tick-circle.svg').default} alt='' /></h5>
                                <div className='mt-2'>
                                    <label>{t('Receiving Wallet')}</label>
                                  
     
<p>{displayWalletAddress()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </>
    );
}

export default Myprofile;